import { AnimatePresence, motion } from 'framer-motion';
import { Heart, Menu, X } from 'lucide-react';
import { useState } from 'react';
import { birthdayConfig } from '../config';
import { useActiveSection } from '../hooks/useActiveSection';

export function FloatingNav() {
  const [open, setOpen] = useState(false);
  const ids = birthdayConfig.navigation.map((item) => item.id);
  const activeId = useActiveSection(ids);

  const goTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setOpen(false);
  };

  return (
    <>
      <nav className="floating-nav glass" aria-label="Birthday page navigation">
        <button className="nav-brand" onClick={() => goTo('home')} aria-label="Go to home section">
          <Heart size={18} fill="currentColor" />
          <span>{birthdayConfig.birthdayPerson.name}</span>
        </button>
        <div className="desktop-nav-links">
          {birthdayConfig.navigation.map((item) => (
            <button
              key={item.id}
              className={activeId === item.id ? 'active' : ''}
              onClick={() => goTo(item.id)}
            >
              {item.label}
            </button>
          ))}
        </div>
        <button className="icon-button mobile-menu-button" onClick={() => setOpen((value) => !value)} aria-label="Open navigation menu">
          {open ? <X /> : <Menu />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            className="mobile-nav-drawer glass"
            initial={{ opacity: 0, x: '-50%', y: -20, scale: 0.97 }}
            animate={{ opacity: 1, x: '-50%', y: 0, scale: 1 }}
            exit={{ opacity: 0, x: '-50%', y: -14, scale: 0.97 }}
          >
            {birthdayConfig.navigation.map((item) => (
              <button key={item.id} className={activeId === item.id ? 'active' : ''} onClick={() => goTo(item.id)}>
                {item.label}
              </button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>

      <div className="section-dots" aria-label="Section progress">
        {birthdayConfig.navigation.map((item) => (
          <button
            key={item.id}
            className={activeId === item.id ? 'active' : ''}
            onClick={() => goTo(item.id)}
            aria-label={`Go to ${item.label}`}
          />
        ))}
      </div>
    </>
  );
}
